import React from 'react';

const CompactContext = React.createContext(false);

export default CompactContext;
